/* eslint-disable react/no-danger */
import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PlanDisplay from 'components/PlanDisplay'
import VoucherCodeField, { VOUCHER_LENGTH } from 'components/form/VoucherCodeField'
import styles from './styles.scss'
import * as planActions from './actions'
import { VOUCHER_CODE } from './constants'

class PlanSelectionStage extends PureComponent {
  static propTypes = {
    // From Wagtail
    mainTitle: PropTypes.string,
    tagLine: PropTypes.string,
    plans: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      rate: PropTypes.number,
      interval: PropTypes.string,
      isPromo: PropTypes.bool,
      promoText: PropTypes.string,
      limit: PropTypes.string,
      pricingInfo: PropTypes.string,
      planColor: PropTypes.string,
      secondaryPlanColor: PropTypes.string,
      speedDisclaimer: PropTypes.string,
      features: PropTypes.string,
      terms: PropTypes.string,
      serviceClasses: PropTypes.arrayOf(PropTypes.number),
    })),
    buttonText: PropTypes.string,
    terms: PropTypes.string,
    fieldValues: PropTypes.object,
    fieldErrors: PropTypes.object,
    voucher: PropTypes.string,
    planSelected: PropTypes.object,
    enableVouchers: PropTypes.bool,

    // From action creator
    selectPlan: PropTypes.func,
    setFieldValues: PropTypes.func,
    clearVoucher: PropTypes.func,

    // from redux
    installAddressClass: PropTypes.number,
    productFeatureAvailability: PropTypes.arrayOf(PropTypes.string),
  }

  static defaultProps = {
    mainTitle: 'Kogan Internet is Available!',
    tagLine: 'Select your internet package to continue',
    buttonText: 'Choose Plan',
    terms: '',
    voucher: '',
    plans: [],
    enableVouchers: true,
    selectPlan: f => f,
    setFieldValues: f => f,
    clearVoucher: f => f,
    fieldValues: {},
    fieldErrors: {},
    planSelected: {},
    installAddressClass: null,
    productFeatureAvailability: [],
  }

  constructor(props) {
    super(props)
    this.state = {
      useVoucher: !!this.props.voucher,
    }
  }

  componentWillUnmount() {
    // When moving to next step, scroll position is below fold
    window.scrollTo(0, 0)
  }

  onFieldChange = event => this.props.setFieldValues({ [event.target.name]: event.target.value })

  onPlanSelect = (plan) => {
    if (plan.redirectLink) {
      window.open(plan.redirectLink, '_self')
      return
    }

    if (this.canContinueWithVoucher()) {
      // A voucher was entered, force selection of that one
      this.props.selectPlan(this.props.planSelected, this.props.voucher)
    } else {
      // Non-voucher selection
      this.props.selectPlan(plan)
    }
  }

  handleUseVoucherClick = () => {
    this.setState({ useVoucher: true })
  }

  handleCancelVoucher = () => {
    this.setState({ useVoucher: false }, () => {
      this.props.clearVoucher()
    })
  }

  canContinueWithVoucher = () => {
    const { planSelected, voucher, fieldValues } = this.props
    const inputValue = fieldValues[VOUCHER_CODE] || ''
    return !!planSelected && !!voucher && inputValue.length === VOUCHER_LENGTH
  }

  render() {
    const {
      plans: allPlans,
      mainTitle,
      tagLine,
      terms,
      fieldValues,
      fieldErrors,
      buttonText,
      planSelected,
      enableVouchers,
      installAddressClass,
      productFeatureAvailability,
    } = this.props
    const showDisclaimer = installAddressClass === null
    const plans = allPlans.filter((plan) => {
      if (plan.availableProductFeatures.length > 0) {
        if (productFeatureAvailability) {
          return plan.availableProductFeatures.some(pfa => productFeatureAvailability.includes(pfa))
        }
        return false
      }

      return (showDisclaimer
        || plan.serviceClasses.length === 0
        || plan.serviceClasses.includes(installAddressClass)
      )
    })
    const buttonTexts = plans.map(() => buttonText)
    const onButtonClicks = plans.map(plan => () => this.onPlanSelect(plan))

    const showVoucherPlan = this.canContinueWithVoucher()
    return (
      <div className={styles.planWrapper}>
        <h1 className={styles.pageTitle}>{mainTitle}</h1>
        <div
          dangerouslySetInnerHTML={{ __html: tagLine }}
        />
        {enableVouchers &&
          <div className={styles.voucherWrapper}>
            <div className="l-page--width">
              {this.state.useVoucher ? (
                <Fragment>
                  <p>
                    <strong>Use purchased voucher code</strong>
                    <button onClick={this.handleCancelVoucher} className={styles.cancelButton}>Cancel</button>
                  </p>
                  <div className={styles.inputWrap}>
                    <VoucherCodeField
                      name={VOUCHER_CODE}
                      label="Enter your voucher code"
                      onChange={this.onFieldChange}
                      onBlur={this.onFieldChange}
                      value={fieldValues[VOUCHER_CODE]}
                      errorMessage={fieldErrors[VOUCHER_CODE]}
                      required
                      focusOnMount
                    />
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <strong>Have you already purchased a voucher code?</strong>
                  <button onClick={this.handleUseVoucherClick} className={styles.linkButton}>
                    Use Purchased Voucher
                  </button>
                </Fragment>
              )}
            </div>
          </div>
        }
        <PlanDisplay
          plans={showVoucherPlan ? [planSelected] : plans}
          summary={showVoucherPlan}
          buttonTexts={buttonTexts}
          onButtonClicks={onButtonClicks}
          showEligibility={false}
        />
        <div
          className={styles.terms}
          dangerouslySetInnerHTML={{
            __html: terms,
          }}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  const {
    planFields,
    planErrors,
    voucher,
    planSelected,
    installAddressClass,
    productFeatureAvailability,
  } = state.checkoutReducer

  return {
    fieldValues: planFields,
    fieldErrors: planErrors,
    voucher,
    planSelected,
    installAddressClass,
    productFeatureAvailability,
  }
}

export default connect(mapStateToProps, {
  selectPlan: planActions.selectPlan,
  setFieldValues: planActions.setFieldValues,
  clearVoucher: planActions.clearVoucher,
})(PlanSelectionStage)



// WEBPACK FOOTER //
// ./containers/stages/PlanSelectionStage/index.jsx